import { api } from "../middlewares";

import translateVector from "../Utils/translator";
import { translateBuilding } from "../Utils/translateFunctions";
async function getImoveis() {
  let resultGetImoveis = "";
  let temp = "";
  try {
    resultGetImoveis = await api.get("MeuImovel/GetImoveis");
    temp = translateVector(resultGetImoveis.data, translateBuilding);
    return temp;
  } catch (error) {
    return error.request;
  }
}

async function getTimeline(empreendimentoID) {
  let resultGetTimeline = "";
  try {
    resultGetTimeline = await api.get("MeuImovel/GetTimeLine", {
      params: {
        Empreendimento_id: empreendimentoID,
      },
    });
    return resultGetTimeline.data;
  } catch (error) {
    return false;
  }
}

async function getNoticias(empreendimentoID) {
  let resultGetNoticias = "";
  try {
    resultGetNoticias = await api.get("MeuImovel/GetNoticias", {
      params: {
        Empreendimento_id: empreendimentoID,
      },
    });
    return resultGetNoticias.data;
  } catch (error) {
    return false;
  }
}

async function getVideos(empreendimentoID) {
  let resultGetVideos = "";
  try {
    resultGetVideos = await api.get("MeuImovel/GetVideos", {
      params: {
        Empreendimento_id: empreendimentoID,
      },
    });
    return resultGetVideos.data;
  } catch (error) {
    return false;
  }
}

async function getEtapasSafi(idOportunidade) {
  let resultGetEtapas = "";
  try {
    resultGetEtapas = await api.get("MeuImovel/GetEtapasSAFI", {
      params: {
        id_oportunidade: idOportunidade,
      },
    });
    return resultGetEtapas.data;
  } catch (error) {
    return false;
  }
}

// empreendimentoID === EmpreendimentoIdSalesForce
async function getDocumentos(
  contratoNumero,
  empreendimentoID,
  oportunidadeIdSalesForce
) {
  let resultGetDocumentos = "";
  try {
    resultGetDocumentos = await api.get("MeuImovel/GetDocumentos", {
      params: {
        contrato_id: contratoNumero,
        Empreendimento_id: empreendimentoID,
        oportunidade_id: oportunidadeIdSalesForce,
      },
    });
    return resultGetDocumentos.data;
  } catch (error) {
    return false;
  }
}

export {
  getImoveis,
  getTimeline,
  getNoticias,
  getVideos,
  getEtapasSafi,
  getDocumentos,
};
